import { ItemGroupSortOption } from '@rematter/frontend-lib-api-client';

import { ItemGroupRecord } from '../types/inventoryItem';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const itemGroupsListQueryAtom = createQueryAtomFactory(
  'settings.itemGroupsList',
  (params: {
    ids?: string[];
    searchTerm?: string;
    parentId?: string;
    limit?: number;
    offset?: number;
    sorting?: ItemGroupSortOption[];
  }) => ({
    itemGroups: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
          parentId: params.parentId,
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 50,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        name: true,
        number: true,
        description: true,
        notes: true,
        defaultPricingUnit: true,
        parentId: true,
        colorHue: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): { itemGroups: ItemGroupRecord[]; totalCount: number } => {
      if (!data?.itemGroups?.entries) {
        return { itemGroups: [], totalCount: 0 };
      }

      return {
        itemGroups: data.itemGroups.entries.map((group) => ({
          id: group.id,
          name: group.name,
          number: group.number,
          description: group.description ?? '',
          notes: group.notes ?? '',
          defaultPricingUnit: group.defaultPricingUnit ?? null,
          colorHue: group.colorHue,
          parent: group.parentId ? { id: group.parentId, name: '' } : null,
          timestamps: {
            createdAt: parseZonedDateTime(group.timestamps.createdAt),
            updatedAt: parseZonedDateTime(group.timestamps.updatedAt),
          },
        })),
        totalCount: data.itemGroups.page?.total ?? 0,
      };
    },
  },
);
